/* ChroMorpher - sticky add-to-cart bar.
   Split out of cm-pdp.js so it can run on any product template without bringing
   the rest of the PDP behaviour with it. No libraries, no external requests.
   The bar starts hidden and stays hidden if this script never runs. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  /* ---------------- Sticky add to cart ---------------- */
  function initSticky() {
    var bar = document.querySelector('[data-cmx-sticky]');
    if (!bar) return;

    // The main product section owns the real form. Its id is only known at render
    // time, so derive it from the DOM rather than hardcoding or guessing.
    var main = document.querySelector('product-info[id^="MainProduct-"]');
    var sectionId = main ? main.id.replace('MainProduct-', '') : bar.getAttribute('data-section');
    if (!sectionId) return;
    var form = document.getElementById('product-form-' + sectionId);
    var submit = document.getElementById('ProductSubmitButton-' + sectionId);
    var priceEl = document.getElementById('price-' + sectionId);
    var info = main || document.getElementById('MainProduct-' + sectionId);
    var buttons = form ? form.closest('.product-form__buttons') || form : null;
    if (!form || !submit) return;

    var barBtn = bar.querySelector('[data-cmx-sticky-btn]');
    var barPrice = bar.querySelector('[data-cmx-sticky-price]');
    var barVariant = bar.querySelector('[data-cmx-sticky-variant]');
    var barImg = bar.querySelector('[data-cmx-sticky-img]');

    var variantMap = {};
    var dataEl = document.getElementById('cmx-variants');
    if (dataEl) { try { variantMap = JSON.parse(dataEl.textContent) || {}; } catch (e) { variantMap = {}; } }

    function currentVariantId() {
      var input = form.querySelector('input[name="id"]');
      return input ? String(input.value || '') : '';
    }

    function sync() {
      var v = variantMap[currentVariantId()];
      // Price comes from the variant map, not from scraping the price block:
      // several products carry a compare-at price, and scraping picks up both
      // numbers and renders "$124.99 USD $41.84".
      if (barPrice && v && v.p) barPrice.textContent = v.p;
      // Availability + label: mirror the real submit button so sold-out states match.
      if (barBtn) {
        barBtn.disabled = !!submit.disabled;
        var label = (submit.textContent || '').replace(/\s+/g, ' ').trim();
        if (label) barBtn.textContent = label;
      }
      // Selected variant name and image.
      if (v) {
        if (barVariant) {
          barVariant.textContent = v.t || '';
          barVariant.hidden = !v.t;
        }
        if (barImg && v.i) barImg.setAttribute('src', v.i);
      }
    }

    // Dawn re-renders the price and button on variant change; observing the
    // product-info subtree is cheaper and more reliable than guessing events.
    if (info && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () { sync(); });
      mo.observe(info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'value'] });
    }
    form.addEventListener('change', sync);
    document.addEventListener('variant:change', sync);
    sync();

    barBtn.addEventListener('click', function () {
      if (barBtn.disabled) return;
      // Submit the real form so Dawn's product-form handler, cart drawer and any
      // app that hooks the form all behave exactly as they do above the fold.
      if (typeof form.requestSubmit === 'function') form.requestSubmit(submit);
      else submit.click();
    });

    // Show the bar once the real buy button has scrolled out of view.
    // A passive, rAF-throttled scroll listener rather than IntersectionObserver:
    // it behaves identically, costs nothing measurable, and works in embedded and
    // emulated viewports where IO's root box does not resolve.
    var anchor = buttons || submit;
    var root = document.documentElement;
    // Menu drawer, search, cart drawer, media / quick-add modals: Dawn locks the
    // page with an overflow-hidden* class on <body> for all of these, and the
    // explicit selectors cover anything that opens without it.
    var OVERLAYS = 'details.menu-drawer-container[open], details-modal details[open], ' +
      'cart-drawer.active, cart-notification .cart-notification.active, ' +
      'product-modal[open], quick-add-modal[open], modal-dialog[open], dialog[open]';
    function overlayOpen() {
      if (/(^|\s)overflow-hidden/.test(document.body.className)) return true;
      return !!document.querySelector(OVERLAYS);
    }
    var ticking = false;
    function evaluate() {
      ticking = false;
      var r = anchor.getBoundingClientRect();
      var past = r.bottom < 8;                       // buy button scrolled above the fold
      var atFooter = (window.innerHeight + window.pageYOffset) > (document.body.scrollHeight - 120);
      var show = past && !atFooter && !overlayOpen();
      bar.setAttribute('data-shown', show ? 'true' : 'false');
      // Tell the page the bar is up, so the chat button can move out of its way
      // (see cm-sticky.css). The height is measured because it grows with the
      // iOS safe-area inset.
      if (show) root.style.setProperty('--cm-sticky-h', Math.round(bar.offsetHeight) + 'px');
      root.classList.toggle('cm-sticky-on', show);
    }
    var raf = window.requestAnimationFrame ? window.requestAnimationFrame.bind(window)
                                            : function (cb) { return setTimeout(cb, 16); };
    function onScroll() {
      if (ticking) return;
      ticking = true;
      raf(evaluate);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    // Re-check whenever something opens or closes.
    if ('MutationObserver' in window) {
      new MutationObserver(onScroll).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
    document.addEventListener('toggle', onScroll, true);
    evaluate();
  }

  ready(initSticky);
})();
